module.exports = __webpack_public_path__ + "img/sign-16.5a08253a.jpg";